import { Navigate } from 'react-router-dom';
import Loader from '../Shared/Loader';
import { useSaasSession } from '../../saas/SessionContext';

export default function PlatformAdminRoute({ children }) {
  const { loading, user } = useSaasSession();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.forcePasswordChange) return <Navigate to="/change-password" replace />;
  if (user.platformRole !== 'platform_admin') return <Navigate to="/access-status" replace />;
  return children;
}
